import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  connect() {
    this.element.addEventListener("mouseenter", this.show.bind(this))
    this.element.addEventListener("mouseleave", this.hide.bind(this))
    this.element.addEventListener("focusin", this.show.bind(this))
    this.element.addEventListener("focusout", this.hide.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.show.bind(this))
    this.element.removeEventListener("mouseleave", this.hide.bind(this))
    this.element.removeEventListener("focusin", this.show.bind(this))
    this.element.removeEventListener("focusout", this.hide.bind(this))
  }

  show() {
    const tooltip = this.element.querySelector('[role="tooltip"]')
    if (tooltip) {
      tooltip.classList.remove("opacity-0")
      tooltip.classList.add("opacity-100")
    }
  }

  hide() {
    const tooltip = this.element.querySelector('[role="tooltip"]')
    if (tooltip) {
      tooltip.classList.remove("opacity-100")
      tooltip.classList.add("opacity-0")
    }
  }
}
